<template>
  <form v-on:submit.prevent="payAndGet" class="stripe-card rounded px-4 py-5">
    <div id="card" class="border rounded p-3 mb-3 w-100 bg-white stripe-card__input"></div>
    <button class="btn btn-light btn-lg w-100" type="submit" :disabled="loading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
      <span v-else>{{ $t('payment.payAndGet') }}</span>
    </button>
  </form>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'

const elementClasses = {
  focus: 'border-theme',
  invalid: 'border-danger'
}

export default {
  data() {
    return {
      card: null,
      stripe: null
    }
  },
  async mounted() {
    if (!this.stripeApiKey) {
      const key = await this.startPaymentRequest()

      this.stripe = await loadStripe(key)
      this.initStripeCard()
    } else {
      this.stripe = await loadStripe(this.stripeApiKey)
      this.initStripeCard()
    }
  },
  computed: {
    ...mapState('payment', ['loading']),
    ...mapGetters('payment', ['stripeApiKey'])
  },
  methods: {
    ...mapActions('payment', ['startPaymentRequest', 'confirmPaymentRequest']),
    initStripeCard() {
      const elements = this.stripe.elements({ locale: this.$i18n.locale || 'en' })

      this.card = elements.create('card', {
        classes: elementClasses
      })
      this.card.mount('#card')
    },
    async payAndGet() {
      const payload = {
        stripeInstance: this.stripe,
        card: this.card
      }
      const confirmed = await this.confirmPaymentRequest(payload)

      if (confirmed) {
        this.$emit('paid')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables.scss";
.stripe-card{
  background-color: $theme;
  background: linear-gradient(45deg, darken($theme, 5%), $blue);
  &__input{
    min-height: 50px;
  }
}
</style>
